import React from 'react';

import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { InfoIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { COLOR_PALETTE } from 'constants/ui';

import { PropertyAndLoanTestIds } from '../../../../../PropertyAndLoan.testIds';

const defaultArray = [];

const tableCellSx = { color: COLOR_PALETTE.GRAY[1], border: 'none' };

const AdjustmentsTooltip = ({ label, adjustments = defaultArray }) => {
  return (
    <Typography className="flex items-center" variant="regular14">
      {`${label} `}

      <Tooltip
        placement="bottom"
        title={
          <TableContainer data-testid={PropertyAndLoanTestIds.PROGRAM_ADJUSTMENTS_TABLE}>
            <Table>
              <TableBody>
                {!_.size(adjustments) && (
                  <Typography sx={tableCellSx} variant="regular14">
                    There are no adjustments
                  </Typography>
                )}

                {adjustments.map(({ name, amount }, index) => (
                  <TableRow key={index}>
                    <TableCell sx={tableCellSx}>{name}</TableCell>
                    <TableCell align="right" sx={tableCellSx}>
                      {amount}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      >
        <IconButton
          disableRipple
          data-testid={PropertyAndLoanTestIds.PROGRAM_ADJUSTMENTS_INFO_BUTTON}
          size="small"
        >
          <InfoIcon size={18} />
        </IconButton>
      </Tooltip>
    </Typography>
  );
};

AdjustmentsTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  adjustments: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    }),
  ),
};

export default AdjustmentsTooltip;
